/**
 * Created by rickborst on 21/08/2017.
 */

import _ from 'lodash';

import {
    isValidResponse
} from '../validators/epg';
import {
    convertFromRead
} from '../adapters/epg';

import {ViewNames} from 'models/view';
import EpgSection from 'models/epgsection';

let channelsPromise = null,
    epgPromise = null;

/**
 * Returns channels for the epg.
 *
 * @returns {Array} EPG channels.
 */
function getEpgChannels () {

    return channelsPromise
        || (channelsPromise =
            this._dataSources.getConfig().then((config) => {
                return _.get(config, ['_presets', 'assetTypes', 'LINEAR']);
            }).then((linearTypeId) => {
                return this._dataSources.getLinearChannels(linearTypeId);
            }).then(results => {
                let channels = [];

                _.forEach(results.getChannels(), channel => {

                    channels.push(channel);
                });

                return channels;
            }));
}

/**
 * Returns EPG section based on start and end of time window.
 *
 * @param {Object} params - Params object.
 * @returns {Object} EPG section.
 */
function getEpgSection (params) {

    if (!epgPromise) {

        epgPromise = this._dataSources.getViewByName(
            ViewNames.EPG,
            {
                pagination: {
                    pageSize: 1000
                }
            });
    }

    return epgPromise.then(response => {

        if (!isValidResponse(response)) {

            return Promise.reject(response);
        }

        return response;
    })
    .then(response => {
        let promiseStack = [],
            {modules} = response,
            assetsRrequestParams = {
                pageSize: 1000,
                pageIndex: 1,
                rail: null
            };

        _.forEach(modules, (module) => {
            assetsRrequestParams.rail = module;

            promiseStack.push(this._dataSources.loadRailAssets(assetsRrequestParams).then((data) => {

                let assets = data.assets.sort((asset1, asset2) => {
                    return asset1.start - asset2.start;
                });

                module.assets = _.merge(module.assets, assets);
            }));

        });

        return Promise.all(promiseStack).then(() => {
            let data = convertFromRead.call(this, response, params);

            return new EpgSection(data);
        });
    });
}

export {
    getEpgChannels,
    getEpgSection
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/epg.js